import { render, staticRenderFns } from "./HeadToHead.vue?vue&type=template&id=55822bf9&scoped=true&"
import script from "./HeadToHead.vue?vue&type=script&lang=js&"
export * from "./HeadToHead.vue?vue&type=script&lang=js&"
import style0 from "./HeadToHead.vue?vue&type=style&index=0&id=55822bf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55822bf9",
  null
  
)

export default component.exports